import { createFileRoute } from '@tanstack/react-router'

import { redirectNlUsersToPaymentMethods } from '#/shared/routing/redirect-nl-users-to-payment-methods.ts'

// The NL guard sits on the layout so both the list and the payment screen inherit it. Per-screen
// permissions live on the leaves, which need different ones (read vs pay).
//
// This remains an intentional legacy handoff while v2 is internal-only. Do not redirect it to a v2 route
// until an explicit customer-portal cutover changes the external-entry policy.
export const Route = createFileRoute('/(customer)/_shell/unpaid-invoices-v2')({
  beforeLoad: ({ context }) => redirectNlUsersToPaymentMethods(context),
})
